module.exports = "/assets/data/7605a868fbf403485b2da0a44dba6bcf-L23.data.json";